module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-76x76-cd7d99a054495d5ab20a049e5014cee9.png";